export class GetLastPricesFutureRequest {
  productCodes: Array<string>;
  typeProductQuotes: number;
}
